export function buildGr4vyMetadata(
  input: Record<string, unknown> | undefined,
  intent: string
) {
  const base = input ?? {};
  const stringified = Object.fromEntries(
    Object.entries(base).map(([key, value]) => [key, String(value)])
  );
  return { ...stringified, intent: String(intent) } as Record<string, string>;
}
